import React from "react";
import StationForm from "./StationForm";

export default function StationEdit() {
  return <StationForm mode="edit" />;
}
